<template>
  <div class="activitiesCommunity">
    <Header></Header>
    <Nav type="6" @getStoreChildren='getStoreChildren'></Nav>
    <Toptitle title="驿活动"></Toptitle>
    <div class="activitiesCommunity_nav">
      <router-link tag="a" to="/activitiesCommunity" class="selection">活动社区</router-link>
      <router-link tag="a" to="/exhibition">作品展示</router-link>
      <router-link tag="a" to="/store">驿道商店</router-link>
    </div>
    <div class="banner">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(slide,index) in swiperSlides" :key="index">
          <div class="swiper_img">
            <img :src="slide.picture" alt="">
            <span></span>
            <p>{{slide.title}}</p>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev" slot="button-prev">

        </div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
    <div class="activitiesCommunity_list">
      <div class="activitiesCommunity_item" v-for="(item,index) of activeList" :key='index' v-if="item.status == 0">
        <div class="activitiesCommunity_item_img">
          <img :src="item.picture">
        </div>
        <div class="activitiesCommunity_item_right">
          <!-- <h3>世界上最珍贵5种水果，一个比一个奇葩，若你全吃过，绝对土豪了</h3>
          <p>世界上最珍贵5种水果，一个比一个奇葩，若你全吃过，绝对土豪了！在我们平常的生活中，水果的种类是非常多的，虽然说水果只有硬气的起来的口感才是非常鲜嫩美</p>
          <div>
            <span><img src="../assets/static/images/activitiesCommunityIcon1.png" alt="">南粤古驿道</span>
            <span><img src="../assets/static/images/activitiesCommunityIcon2.png" alt="">4.930万</span>
            <span><img src="../assets/static/images/activitiesCommunityIcon3.png" alt="">5</span>
          </div> -->
          <h3>{{item.name}}</h3>
          <span class="activeDate">活动报名时间：{{item.beginnamedtime}} ～ {{item.endnamedtime}}</span>
          <span class="activeDetail_text" @click="goActiveDetail(item.id)">查看详情 >></span>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './common/Header.vue'
  import Nav from './common/Nav.vue'
  import Footer from './common/Footer.vue'
  import 'swiper/dist/css/swiper.css'
  import {
    swiper,
    swiperSlide
  } from 'vue-awesome-swiper'
  import {
    request
  } from 'http';
  import Toptitle from './common/Toptitle.vue'
  export default {
    data() {
      return {
        swiperOption: {
          notNextTick: true,
          // autoplay: true,
          pagination: {
            el: '.swiper-pagination'
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
        swiperSlides: [],
        navID: '',
        activeList:[],
        isCanName:true
      }
    },
    components: {
      Header,
      Footer,
      Nav,
      swiper,
      swiperSlide,
      Toptitle
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    methods: {
      getActiveList() {
        this.axios.post('/api/a_activity/getList.do', this.qs(null)).then(res => {
          if(res.status == 200){
            for(let item of res.data.page.results){
              item.beginnamedtime = this.$moment(item.beginnamedtime).format('YYYY-MM-DD HH:mm')
              item.endnamedtime = this.$moment(item.endnamedtime).format('YYYY-MM-DD HH:mm')
            }
            this.activeList = res.data.page.results
            console.log(res)
          }
        })
      },
      getBanners() {
        this.axios.post('api/b_bannermag/getListByNavId.do', this.qs({
          navigateid: this.navID
        })).then(res => {
          if (res.status == 200) {
            this.swiperSlides = res.data.data
          }
        })
      },
      getStoreChildren(data) {
        this.navID = data[0].value.id
        this.getBanners()
      },
      goActiveDetail(id){
        this.$router.push({
          name:'activiteDetail',
          query:{
            id:id
          }
        })
      }
    },
    mounted() {
      this.getActiveList()
      // if(sessionStorage.getItem('active')){
      //   this.navID = JSON.parse(sessionStorage.getItem('active'))[0].value.id
      // }
      
    }
  }
</script>

<style>
</style>
